import { FC, MouseEvent, ReactNode } from 'react'
import { toast } from '@/components/toast'
import { copyToClipboard } from '@/utils/copy-clipboard'

export interface CopyToClipboardProps {
  children: ReactNode
  textToCopy: string
  onSuccess?: (event: MouseEvent) => void
  onClick?: (event: MouseEvent) => void
  className?: string
  showToast?: boolean
  toastMessage?: string
}

export const CopyToClipboard: FC<CopyToClipboardProps> = ({
  children,
  className,
  textToCopy,
  onClick,
  onSuccess,
  showToast = true,
  toastMessage
}) => {
  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    onClick?.(event)
    copyToClipboard(textToCopy, () => {
      onSuccess?.(event)
      if (showToast) {
        toast({
          type: 'success',
          autoClose: 3000,
          title: toastMessage ?? '¡Copiado!'
        })
      }
    })
  }

  return (
    <button type="button" onClick={handleClick} className={className}>
      {children}
    </button>
  )
}

export default CopyToClipboard
